import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { useUIDSeed } from 'react-uid'
import { withTranslation } from 'server/i18n'

import { ContactsItem } from 'components/Contacts'

import style from './Contacts.style'

const ContactsStyled = styled.div(props => ({ ...style(props) }))

const Contacts = ({ data, t, i18n }) => {
    const uid = useUIDSeed()

    return data && data.length > 0 ? (
        <ContactsStyled>
            <h3 className="contactsTitle">{t('your-contact-person')}.</h3>
            <ul className="contactsList">
                {data.map(item => (
                    <li key={uid(item)} className="contactsList-item">
                        <ContactsItem
                            image={item.image}
                            name={item.name}
                            position={i18n.language === 'en' ? item.role.roleEn : item.role.roleDe}
                            speaking={item.languages}
                            phone={item.phone}
                            email={item.email}
                        />
                    </li>
                ))}
            </ul>
        </ContactsStyled>
    ) : null
}

Contacts.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.string,
            name: PropTypes.string,
            // eslint-disable-next-line react/forbid-prop-types
            position: PropTypes.object,
            speaking: PropTypes.string,
            description: PropTypes.string
        })
    ),
    i18n: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
    t: PropTypes.func.isRequired
}

Contacts.defaultProps = {
    data: []
}

export default withTranslation()(withTheme(Contacts))
